<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="copyright-page">
<p class="copy1"><a id="page_4"><em><strong>Letters Written and Not Sent</strong></em></a></p><a id="page_4">
<p class="copy">Copyright © 2019 by The Estate of William Louis-Dreyfus</p>
<p class="copy1">All Rights Reserved</p>
<p class="copy1">No part of this book may be used or reproduced in any manner whatsoever without the prior written permission of both the publisher and the copyright owner.</p>
<p class="copy1">Book design by Mark E. Cull</p>
<p class="copy1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Names: Louis-Dreyfus, William, 1932–2016, author.</p>
<p class="copy">Title: Letters written and not sent : poems / William Louis-Dreyfus.</p>
<p class="copy">Description: Pasadena, CA : Red Hen Press, [2019]</p>
<p class="copy">Identifiers: LCCN 2018056115 | ISBN 9781597098694 (tradepaper)</p>
<p class="copy">Classification: LCC PS3612.O794 A6 2019 | DDC 811/.6—dc23</p>
</a><p class="copy"><a id="page_4">LC record available at </a><a href="https://lccn.loc.gov/2018056115" target="_blank">https://lccn.loc.gov/2018056115</a></p>
<p class="copy1">The National Endowment for the Arts, the Los Angeles County Arts Commission, the Ahmanson Foundation, the Dwight Stuart Youth Fund, the Max Factor Family Foundation, the Pasadena Tournament of Roses Foundation, the Pasadena Arts &amp; Culture Commission and the City of Pasadena Cultural Affairs Division, the City of Los Angeles Department of Cultural Affairs, the Audrey &amp; Sydney Irmas Charitable Foundation, the Kinder Morgan Foundation, the Allergan Foundation, the Meta &amp; George Rosenberg Foundation, and the Riordan Foundation partially support Red Hen Press.</p>
<p class="copy1"><img alt="Images" src="images/copy.jpg"/></p>
<p class="copy1">First Edition</p>
<p class="copy">Published by Red Hen Press</p>
<p class="copy"><a href="http://www.redhen.org" target="_blank">www.redhen.org</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?071ad0aa